/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import provideStores from './provide-stores'

export const wrapRootElement = provideStores